import React from "react";
import styles from "./AboutUs3.module.css";

const AboutUs3 = ({ aboutData }) => {
  if (!aboutData) return null;

  return (
    <section id="about" className={styles.section}>
      <div className={styles.container}>

        <div className={styles.grid}>

          {/* IMAGE COLLAGE */}
          <div className={styles.images}>

            <img src={aboutData.image} alt="about" className={styles.mainImg}/>

            <div className={styles.overlayCard}>
              <h3>12+</h3>
              <p>Years Of Travel Experience</p>
            </div>

          </div>

          {/* TEXT */}
          <div className={styles.text}>

            <span className={styles.badge}>About Us</span>

            <h2 className={styles.title}>
              {aboutData.title}
            </h2>

            <p className={styles.description}>
              {aboutData.description}
            </p>

            <ul className={styles.list}>
              <li>Best Price Guarantee</li>
              <li>Professional Travel Experts</li>
              <li>Custom Travel Packages</li>
              <li>24/7 Customer Support</li>
            </ul>

            <button className="btn btn-primary btn-lg mt-3">
              Learn More
            </button>

          </div>

        </div>

      </div>
    </section>
  );
};

export default AboutUs3;